module.exports = __webpack_public_path__ + "static/img/notion.7c71d08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/notion.png
// module id = D3RG
// module chunks = 61